import React from 'react'
import Text from 'core-system/Text/Text'
import palette from 'core-system/Themes/palette'

interface ProgramSectionSubHeadingProps {
  title: string
  subtitle?: string | React.ReactNode
}

const ProgramSectionSubHeading = ({
  title,
  subtitle,
}: ProgramSectionSubHeadingProps) => {
  return (
    <>
      <Text variant='h5' marginBottom='1.5rem'>
        {title}
      </Text>
      {subtitle && (
        <Text
          variant='body1'
          marginBottom='1.5rem'
          color={palette.text.primary}
        >
          {subtitle}
        </Text>
      )}
    </>
  )
}

export default React.memo(ProgramSectionSubHeading)
